import { PriceType } from "../models/price-type";
import { httpGet } from "./http-client";

const apiUrl = '/api/pricetypes';

export const getPriceTypes = () => httpGet<PriceType[]>(apiUrl);
